// Auto Layout pipeline entry point — v1 scope: rank-assignment only (rule 1,
// "pijlen altijd naar beneden"). ColumnOrdering (rule 2) and AnchorAttraction
// (rule 4) are future pipeline steps, not built yet — see implementation-detail
// note rk=f114ae65b0584e8e830998f6ad456911. Within a rank, shapes are simply
// stacked left-to-right (same stagger idea as the old Core/UmlAutoLayout.js
// stub, not the final column-ordering strategy).
//
// Operates on TOP-LEVEL shapes only (umlCanvasEngine.shapes) — nested shapes
// (classes inside a package) move automatically when their package moves,
// via umlCanvasEngine.updateShapePosition's translateChildren.
import { assignRanks } from './RankAssignment';

const MARGIN = 40;
const ROW_GAP = 60;
const COLUMN_GAP = 40;

/**
 * @param {object[]} shapes - top-level shapes (umlCanvasEngine.shapes)
 * @param {object[]} connectors - all connectors (umlConnectorEngine.connectors)
 * @returns {{positions: {shapeId: string, x: number, y: number}[], warnings: string[]}}
 */
export function runAutoLayout(shapes, connectors) {
    const { ranksById, warnings } = assignRanks(shapes, connectors);

    const byRank = new Map();
    shapes.forEach(function groupByRank(shape) {
        const rank = ranksById.get(shape.id) ?? 0;
        if (!byRank.has(rank)) byRank.set(rank, []);
        byRank.get(rank).push(shape);
    });

    const positions = [];
    let cursorY = MARGIN;
    [...byRank.keys()]
        .sort(function ascending(a, b) { return a - b; })
        .forEach(function layoutRow(rank) {
            let cursorX = MARGIN;
            let rowHeight = 0;
            byRank.get(rank).forEach(function layoutShape(shape) {
                positions.push({ shapeId: shape.id, x: cursorX, y: cursorY });
                cursorX += shape.w + COLUMN_GAP;
                rowHeight = Math.max(rowHeight, shape.h);
            });
            cursorY += rowHeight + ROW_GAP;
        });

    return { positions, warnings };
}
